import { render, staticRenderFns } from "./permission_management.vue?vue&type=template&id=c5d90a94&scoped=true&"
import script from "./permission_management.vue?vue&type=script&lang=js&"
export * from "./permission_management.vue?vue&type=script&lang=js&"
import style0 from "./permission_management.vue?vue&type=style&index=0&id=c5d90a94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d90a94",
  null
  
)

export default component.exports